import * as React from 'react';
import { Timer } from 'react-soundplayer/components';
import { withCustomAudio } from 'react-soundplayer/addons';
import wrapStore from '@src/utils/wrap-store';
import Store from './store';
import $$tracker from '@src/tracker';
const styles = require('./index.less');

const AudioController = withCustomAudio(({ store, ...rest }) => {
  store.use(rest);

  return (
    <div className={styles.audioController}>
      <div className="media-music-group-14" data-name="播放器组件">
        <div className="media-music-group-19" data-name="进度条">
          {/* <audio src={store.currentAudio?.audioUrl} className={styles.audio} /> */}
          <div className="media-music-layer-43" />
          <div className="media-music-layer-44" style={{ backgroundSize: `${store.currentAudioProgress}% 100%` }} />
          <div className="media-music-layer-45" style={{ left: `${store.currentAudioProgress}%` }} />
          <input
            type="range"
            value={store.currentAudioProgress}
            className={styles.progressController}
            step={store.audioProgressStep}
            onChange={store.audioProgressChange}
          />
        </div>
        <div className="media-music-group-15" data-name="内容">
          <div className="media-music-layer-35" data-name="02:12 / 04:18">
            <Timer currentTime={store.currentTime} duration={store.duration} />
          </div>
          <div className="media-music-group-16" data-name="上一首下一首">
            <div className="media-music-layer-40" onClick={store.prevAudio} />
            <div
              className="media-music-group-17"
              data-name="播放暂停"
              onClick={() => {
                store.playAudio();
                $$tracker.clickStzxPlayMusic(store.currentAudio?.title);
              }}
            >
              <div className="media-music-layer-37" />
              {store.playing ? <div className="media-music-layer-38" /> : <div className="media-music-layer-39" />}
            </div>
            <div className="media-music-layer-36" onClick={store.nextAudio} />
          </div>

          <div className="media-music-group-18" data-name="歌名和歌手">
            <div className="media-music-layer-42" data-name="三生三世">
              {store.currentAudio?.title}
            </div>
            <div className="media-music-layer-41" data-name="王蓉、萧正南">
              {store.currentAudio?.singer}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default wrapStore(({ store }) => {
  return <AudioController store={store} streamUrl={store.currentAudio?.audioUrl} preloadType="metadata" onCanPlayTrack={store.onCanPlayTrack} />;
}, Store);
